const url = "./assets/page/steps/step3/icons/";

const options = [
    {
        content: " ",
        icon: true,
        text: "Nenhuma",
        url: `${url}roof_any.svg`,
    },
    {
        content: "milk",
        icon: true,
        text: "L. Conden.",
        url: `${url}roof_milk.svg`,
    },
    {
        content: "nutella",
        icon: true,
        text: "Nutella",
        url: `${url}roof_nutella.svg`,
    },
    {
        content: "caramel",
        icon: true,
        text: "Doce Leite",
        url: `${url}roof_caramel.svg`,
    },
    {
        content: "raspberry",
        icon: true,
        text: "Framboesa",
        url: `${url}roof_raspberry.svg`,
    },
];

export default options;
